module.exports = __webpack_public_path__ + "img/target_c3674.png";